/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"ml-0 theme--light primary"},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('i',{staticClass:"pr-2",class:_vm.icon}),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }